import React, { useState, useEffect } from 'react';
import { Container, Content, i18n, tokens, Button } from '@simplybenefits/sb-ui-library';
import { connect } from "react-redux";
import { setCurrentSidebarItem } from '../../actions/user.js';
import Card from '../Card/index.js';
import Details from './Details.js';
import { downloadPDFToBrowser } from '../../services/helpers.js';
import { usePlanDetailsState } from './hooks/usePlanDetailsState.js';
import PlanDetailsHeader from './PlanDetailsHeader.js';

/**
 * 
 * @param {*} param0 
 */
const DownloadButton = ({ displayPlanDetails = false, dispatch }) => {
    const styles = {
        downloadBtnContainer: {
            display: 'flex',
            flex: 1,
            justifyContent: 'flex-end',
            marginBottom: 10,
            marginRight: 65
        }
    };

    const componentName = displayPlanDetails ? 'PlanDetails' : 'MyCard';
    const fileName = displayPlanDetails ? 'Plan_Details.pdf' : 'Benefits_Card.pdf';

    return (
        <div style={ styles.downloadBtnContainer }>
            <Button transparent onClick={ () => downloadPDFToBrowser(componentName, fileName, dispatch) }>
                { i18n.t(tokens.buttons["download printable version"])}
            </Button>
        </div>
    );
};

/**
 * 
 * @returns 
 */
const index = ({ meta, dispatch }) => {
    const { shouldHideBenefitsCard } = usePlanDetailsState(meta);
    const [ displayPlanDetails, setDisplayPlanDetails ] = useState(shouldHideBenefitsCard);

    useEffect(() => {
        dispatch(setCurrentSidebarItem('benefits-card'));
    }, []);
    
    /**
     * Toggles between Benefits Card and Plan Details views.
     *
     * Uses the functional setState pattern to safely invert the current state
     * Used as a callback for the BubbleSelectBlock toggle component.
     */
    const handleToggleView = () => setDisplayPlanDetails(!displayPlanDetails);

    return (
        <Container>
            <Content>
                <PlanDetailsHeader
                    showBenefitsCardOption={!shouldHideBenefitsCard}
                    displayPlanDetails={displayPlanDetails}
                    onToggle={handleToggleView}
                />

                <DownloadButton
                    displayPlanDetails={displayPlanDetails}
                    dispatch={dispatch}
                />

                { 
                    displayPlanDetails ? 
                        (
                            <Details />
                        )
                        : (
                            <Card />
                        )
                }
            </Content>
        </Container>
    );
};

/**
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    meta: state.user.meta
});

export default connect(mapStateToProps)(index);